import { useState, useEffect } from "react";
import { useGerenciamento } from "../Context/GerenciamentoContext";
import { Link, useNavigate } from 'react-router-dom';
import "../../App.css";
import "./Forms.css";

import cancelamentoIcon from "../../assets/icons/desmarcar.png";

import AgendamentosService from "../../services/AgendamentosService";
import CancelamentosService from "../../services/CancelamentosService";

export default function CancelamentoForm({
  itemSelecionado,
  modo,
  onClose
}) {
  const [form, setForm] = useState({
    idAgendamento: "",
    idCadastro: "",
    nome: "",
    data: "",
    horario: "",
    motivo: ""
  });

  const [historico, setHistorico] = useState([]);
  const [agendamentoSelecionado, setAgendamentoSelecionado] = useState(null);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const { setRetorno } = useGerenciamento();
  const [submitState, setSubmitState] = useState("IDLE"); 

  // ==========================
  // LOAD MODO
  // ==========================
  useEffect(() => {
    if (modo === "novo") {
      setForm({
        idAgendamento: "",
        idCadastro: "",
        nome: "",
        data: "",
        horario: "",
        motivo: ""
      });
    }

    if (modo === "alterar" && itemSelecionado) {
      setForm({
        idAgendamento: itemSelecionado.IDAGENDAMENTO,
        idCadastro: itemSelecionado.IDCADASTRO || "",
        nome: itemSelecionado.NOME,
        data: itemSelecionado.DATA,
        horario: itemSelecionado.HORARIO,
        motivo: itemSelecionado.MOTIVO
      });
    }
  }, [modo, itemSelecionado]);
  
  
  // ==========================
  // Carregar histórico de Agendamentos
  // ==========================
  useEffect(() => {
    async function carregarDados() {
      try {
        const hist = await AgendamentosService.getCancelar();
        setHistorico(hist);
      } catch (error) {
        console.error("Erro ao carregar dados:", error);
      }
    }
    carregarDados();
  }, []);


  // ==========================
  // Selecionar agendamento
  // ==========================
  function handleSelectAgendamento(e) {
    const id = Number(e.target.value);
  
    if (!id) {
      setAgendamentoSelecionado(null);
      setForm(prev => ({
        ...prev,
        idAgendamento: "",
        idCadastro: "",
        nome: "",
        data: "",
        horario: ""
      }));
      return;
    }
  
    const ag = historico.find(a => a.IDAGENDAMENTO === id);
    setAgendamentoSelecionado(ag);
  
    if (ag) {
      setForm(prev => ({
        ...prev,
        idAgendamento: ag.IDAGENDAMENTO,
        idCadastro: ag.IDCADASTRO,
        nome: ag.NOME,
        data: ag.DATA,
        horario: ag.HORARIO
      }));
    }
  }

  // ==========================
  // HANDLERS
  // ==========================
  function handleChange(e) {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  }

  // ==========================
  // VALIDATION
  // ==========================
  function validarCampos() {
    const e = {};

    if (!form.idAgendamento) e.agendamento = "Selecione um agendamento";
    if (!form.motivo) e.motivo = "Informe o motivo";

    return e;
  }
  
  // ==========================
  // SUBMIT
  // ==========================
  async function handleSubmit(e) {
    e.preventDefault();

    const validation = validarCampos();
    setErrors(validation);

    if (Object.keys(validation).length) return;

    setLoading(true);
    setSubmitState("IDLE");

    try {
      if (modo === "novo") {

        const ag = agendamentoSelecionado;
      
        const payload = {
          IDAGENDAMENTO: ag.IDAGENDAMENTO,
          IDCADASTRO: ag.IDCADASTRO,
          DATA: ag.DATA,
          IDHORARIO: Number(ag.IDHORARIO),
          MOTIVO: form.motivo
        };
      
        await CancelamentosService.cancelarPublico(payload);
      
        setRetorno({
          tipo: "sucesso",
          mensagem: "Agendamento cancelado com sucesso!",
        });
      
        setSubmitState("SUCCESS");
      }

      if (modo === "alterar") {

        setRetorno({
          tipo: "erro",
          mensagem: "Não é possível alterar cancelamentos!",
        });
        setSubmitState("ERROR");
      }

       onClose();
    } catch (error) {
        setRetorno({
          tipo: "erro",
          mensagem:
            modo === "novo"
              ? "Erro ao criar o cancelamento."
              : "Não é possível alterar cancelamentos.",
        });

        setSubmitState("ERROR");

        onClose();
    } finally {
      setLoading(false);
    }
  }

  // ==========================
  // RENDER
  // ==========================
  return (
    <div className="Form-Interno-Container">
      <form onSubmit={handleSubmit}>
        <div className="Form-Interno-title">
          <img src={cancelamentoIcon} alt="cancelamento" className="icon" />
          {modo === "novo" ? "Cadastro de Cancelamentos" : "Alterar Cancelamentos"}
        </div>

        <div className="Form-Interno-linha"></div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Agendamento: *</div>
          <select
              value={form.idAgendamento}
              onChange={handleSelectAgendamento}
            >
              <option value="">Selecione um agendamento</option>

              {historico.map(ag => (
                <option key={ag.IDAGENDAMENTO} value={ag.IDAGENDAMENTO}>
                  {ag.DATA} - {ag.HORARIO.slice(0, 5)} - {ag.DESCRICAO} - {ag.NOME}
                </option>
              ))}
            </select>
          {errors.agendamento && <span className="erro">{errors.agendamento}</span>}
        </div>		
		
        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Nome: *</div>
			      <input value={form.nome} disabled />
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Data: *</div>
			      <input type="text" value={form.data} disabled />
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Horário: *</div>
			      <input type="text" value={form.horario} disabled />
        </div>
		
        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Motivo: *</div>
          <textarea
            name="motivo"
            value={form.motivo}
            onChange={handleChange}
          />
          {errors.motivo && <span className="erro">{errors.motivo}</span>}
        </div>		


        <div className="Form-Interno-alinhamento-button">

          {modo === "novo" && (
            <button type="submit" disabled={loading}className="Form-Interno-button">
              {loading ? "Enviando..." : "Salvar"}
            </button>
          )}

          {modo === "alterar" && (
              <div /*type="submit" disabled={loading}*/
                title="Não é possível alterar Agendamentos Cancelados"
                className="Form-Interno-alinhamento-button-inativo" >
                {/*loading ? "Enviando..." : "Salvar"*/}
                <Link to="/Gerenciamento">Inativo</Link>

              </div>
          )}

          <button type="button" className="Form-Interno-button" onClick={onClose}>
            Voltar
          </button>
        </div>
      </form>
    </div>
  );
}


